export var OAuthProvider = /*#__PURE__*/ function(OAuthProvider) {
    OAuthProvider["Intuit"] = "intuit";
    OAuthProvider["Google"] = "google";
    OAuthProvider["Xero"] = "xero";
    return OAuthProvider;
}({});
export var BusinessPartyTypeEnum = /*#__PURE__*/ function(BusinessPartyTypeEnum) {
    BusinessPartyTypeEnum["MultiVendorCustomer"] = "multiVendorCustomer";
    BusinessPartyTypeEnum["Customer"] = "customer";
    BusinessPartyTypeEnum["Vendor"] = "vendor";
    return BusinessPartyTypeEnum;
}({});
export var BusinessIndustryType = /*#__PURE__*/ function(BusinessIndustryType) {
    BusinessIndustryType["Accounting"] = "accounting";
    BusinessIndustryType["Bookkeeping"] = "bookkeeping";
    BusinessIndustryType["TaxRepresentation"] = "tax";
    BusinessIndustryType["TaxPreparation"] = "tax_preparation";
    BusinessIndustryType["TaxResolution"] = "tax_resolution";
    BusinessIndustryType["Marketing"] = "marketing";
    BusinessIndustryType["Other"] = "other";
    return BusinessIndustryType;
}({});
export var PayoutBankAccountType = /*#__PURE__*/ function(PayoutBankAccountType) {
    PayoutBankAccountType["Connected"] = "connected";
    PayoutBankAccountType["NotConnected"] = "notConnected";
    return PayoutBankAccountType;
}({});
export const isBankAccountConnected = (account)=>!!account && account.type === "connected";
export var KycCompletionStatus = /*#__PURE__*/ function(KycCompletionStatus) {
    /** This is the initial status. */ KycCompletionStatus["InitialIncomplete"] = "initialIncomplete";
    /** KYB data sent to Stripe, waiting to hear back. */ KycCompletionStatus["AwaitingCompletion"] = "awaitingCompletion";
    /** Signifies the user finished KYC. */ KycCompletionStatus["Completed"] = "completed";
    /** After Stripe validation status may change from completed to incomplete. */ KycCompletionStatus["Incomplete"] = "incomplete";
    /** Stripe added new requirements that will be mandatory in the future, so we prompt the user to fill them. */ KycCompletionStatus["CompletedWithFutureRequirements"] = "completedWithFutureRequirements";
    return KycCompletionStatus;
}({});
